export const getOrganizationUuid = () => {
  try {
    const orgUuid = localStorage.getItem('x-organization-uuid');
    if (!orgUuid) {
      console.warn('Organization UUID not found in localStorage');
      return '';
    }
    return orgUuid;
  } catch (error) {
    console.error('Error accessing localStorage:', error);
    return '';
  }
};
